export default function PortalFooter() {
  const cols = [
    {
      title: "栏目导航",
      links: [
        { label: "今日更新", href: "/#today" },
        { label: "热门排行", href: "/rankings" },
        { label: "最新爆料", href: "/latest" },
        { label: "往期回顾", href: "/#review" },
      ],
    },
    {
      title: "了解我们",
      links: [
        { label: "关于我们", href: "/about" },
        { label: "常见问题", href: "/#faq" },
        { label: "新料提醒", href: "/#subscribe" },
        { label: "联系我们", href: "/about#contact" },
      ],
    },
  ];

  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-flashlight-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">曝光导航</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-6 text-foreground-600">
              专注娱乐热点的信息导航平台，聚合综艺、影视、音乐、时尚等圈内动态，以及时的更新与清晰的排行，
              帮你随时跟上吃瓜节奏、不错过任何精彩。
            </p>
            <div className="mt-5 flex gap-3">
              {[
                { icon: "ri-wechat-line", label: "微信公众号" },
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-bilibili-line", label: "B站" },
                { icon: "ri-mail-line", label: "邮箱" },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#subscribe"
                  aria-label={s.label}
                  className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
                >
                  <i className={`${s.icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          {cols.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h3 className="text-sm font-semibold text-foreground-950">{col.title}</h3>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © {new Date().getFullYear()} 曝光导航 · 内容仅供信息参考，不构成任何导向性判断
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
            <a href="/#today" className="text-xs text-foreground-600 hover:text-primary-600">今日更新</a>
            <a href="/#faq" className="text-xs text-foreground-600 hover:text-primary-600">免责声明</a>
            <a href="/about#contact" className="text-xs text-foreground-600 hover:text-primary-600">意见反馈</a>
          </div>
        </div>
      </div>
    </footer>
  );
}